import { Reveal } from "@/components/common/Reveal";
import { PROCESS } from "@/lib/site";

export const ProcessSteps = () => (
  <ol className="relative grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-testid="process-steps">
    <div aria-hidden="true" className="absolute left-0 right-0 top-12 hidden border-t-2 border-dashed border-ink/25 lg:block" />
    {PROCESS.map((s, i) => {
      const Icon = s.icon;
      return (
        <Reveal as="li" key={s.title} delay={i * 0.1} className="relative">
          <div className="card-soft h-full p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lift" data-testid={`process-step-${i + 1}`}>
            <div className="flex items-center justify-between">
              <span className={`grid h-14 w-14 place-items-center rounded-2xl border border-ink/10 ${s.color}`}>
                <Icon className="h-6 w-6" aria-hidden="true" />
              </span>
              <span className="font-heading text-5xl font-semibold text-ink/15" aria-hidden="true">0{i + 1}</span>
            </div>
            <h3 className="mt-6 text-2xl font-semibold"><span className="sr-only">Step {i + 1}: </span>{s.title}</h3>
            <p className="mt-3 text-ink-soft leading-relaxed">{s.text}</p>
          </div>
        </Reveal>
      );
    })}
  </ol>
);
